<template>
    <v-row dense class="table-row w-100">
        <v-col class="col-6 pl-0 name-value-label">
            {{ label }}
        </v-col>
        <v-col class="col-6">
            {{ rating }}
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "CRatingRow",

    props: {
        label: {

        },

        property: {
            required: false,
            default: function () {
                return "rating"
            }
        },

        data: {

        },
    },

    computed: {
        rating () {
            if (!this.data[this.property]) {
                return "---"
            }

            if (this.property === 'vandalism') {
                switch (this.data[this.property]) {
                    case 1: return "keiner";
                    case 2: return "leicht bis mittel (Stufe 1)";
                    case 3: return "stark (Stufe 2)";
                }
                return null;
            }

            switch (this.data[this.property]) {
                case 1: return "Gut";
                case 2: return "Befriedigend";
                case 3: return "Mangelhaft";
                case 4: return "keine Bewertung möglich";
                case 5: return "neue Frequenzregelung empfohlen";
            }

            return null;
        }
    },

    methods: {
        name (id, type) {
            const list = this.$store.getters.msd[type];
            if (list) {
                const item = list.find (i => i.id === id);
                if (item) {
                    return item.name;
                }
            }

            return "---";
        }

    }
}
</script>

<style scoped>

.name-value-label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>